import { useState, useEffect } from "react";
import logger from "../utils/logger";

interface Item {
  id: string;
  value: string;
}

interface ChildProps {
  selectedDistrict: string;
  handleDistrictChange: (v: any) => void;
}

const LoginOptions: React.FC<ChildProps> = ({
  selectedDistrict,
  handleDistrictChange,
}) => {
  const [options, setOptions] = useState<Item[]>([]);
  const [loading, setLoading] = useState(true);

  const backendUrl =
    process.env.REACT_APP_SAML_GATEWAY_URL || "http://localhost:9000";

  useEffect(() => {
    fetch(`${backendUrl}/loginOptions`)
      .then((response) => response.json())
      .then((data) => {
        setOptions(data); // Expecting [{ id: 1, name: 'Option A' }, ...]
        setLoading(false);
      })
      .catch((error) => logger.error("Error fetching options:", error));
  }, [backendUrl]); // Empty dependency array ensures this runs once on mount

  if (loading) return <p>Loading options...</p>;

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const idString = e.target.value;
    const selectedObject = options.find(
      (option: Item) => option.id === idString,
    );
    handleDistrictChange(selectedObject);
  };

  return (
    <label className="field-label">Choose your district
    <br/>&nbsp;<br/>
    <select
      id="district"
      name="district"
      className="select-input"
      required
      value={selectedDistrict}
      onChange={handleChange}
    >
      <option value="" disabled>
        Please select a district
      </option>

      {options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.value}
        </option>
      ))}
    </select>
    </label>
  );
};

export default LoginOptions;
